import { useRegionContext } from '@/contexts/RegionContext';

export function useRegion() {
  return useRegionContext();
}
